module.exports = __webpack_public_path__ + "static/media/ic_btn_dropdown.c9a9df58.svg";